import { connect } from "react-redux";
import CarerSummary from "../components/CarerApp/CarerSummary";
import { mapStateToProps, mapDispatchToProps } from "./CarerAppContainer";

export default connect(mapStateToProps, mapDispatchToProps)(CarerSummary);
